/* BTTO collection infinite scroll (2026-10-23)
   Replaces the visible pagination: when the visitor nears the end of the grid, the next page is fetched
   via the Section Rendering API and its product cards are appended. Works with filters/sorting
   (facets.js re-renders #ProductGridContainer; the pagination links already carry filter/sort params).
   Without JS the normal pagination stays visible (and crawlable). */
(function () {
  if (window.__bttoInfiniteScroll) return;
  window.__bttoInfiniteScroll = true;

  var LABELS = {
    de: { loading: 'Weitere Produkte werden geladen …', more: 'Weitere Produkte laden', error: 'Laden fehlgeschlagen – erneut versuchen' },
    en: { loading: 'Loading more products…', more: 'Load more products', error: 'Loading failed – try again' },
    fr: { loading: 'Chargement d’autres produits…', more: 'Charger plus de produits', error: 'Échec du chargement – réessayer' }
  };
  var L = LABELS[(document.documentElement.lang || 'de').slice(0, 2)] || LABELS.de;

  function pageOf(url) {
    try { return parseInt(new URL(url, location.origin).searchParams.get('page') || '1', 10); } catch (e) { return 1; }
  }

  function nextUrlFrom(nav) {
    if (!nav) return null;
    var cur = nav.querySelector('.pagination__item--current');
    var current = cur ? parseInt(cur.textContent.trim(), 10) : 1;
    var links = nav.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      if (pageOf(links[i].getAttribute('href')) === current + 1) return links[i].getAttribute('href');
    }
    return null;
  }

  function setup(root) {
    var sectionId = root.getAttribute('data-btto-collection-section');
    var container = root.querySelector('#ProductGridContainer');
    if (!container) return;

    if (root._bttoObserver) root._bttoObserver.disconnect();
    if (root._bttoCleanup) root._bttoCleanup();
    var oldLoader = root.querySelector('.btto-inf');
    if (oldLoader) oldLoader.remove();

    var grid = container.querySelector('#product-grid');
    var nav = container.querySelector('.pagination-wrapper');
    var nextUrl = nextUrlFrom(nav);
    root.classList.add('btto-inf-ready');
    if (!grid || !nextUrl) return;

    var loader = document.createElement('div');
    loader.className = 'btto-inf';
    loader.innerHTML =
      '<span class="btto-inf__spinner" aria-hidden="true"></span>' +
      '<span class="btto-inf__text" role="status">' + L.loading + '</span>' +
      '<button type="button" class="btto-inf__btn" hidden>' + L.more + '</button>';
    (nav || grid).insertAdjacentElement(nav ? 'beforebegin' : 'afterend', loader);
    var btn = loader.querySelector('.btto-inf__btn');
    var busy = false;

    function finish() {
      if (root._bttoObserver) root._bttoObserver.disconnect();
      if (root._bttoCleanup) root._bttoCleanup();
      loader.remove();
    }

    function near() {
      return loader.isConnected && loader.getBoundingClientRect().top < window.innerHeight + 900;
    }

    function onScroll() {
      if (!busy && btn.hidden && near()) load();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    root._bttoCleanup = function () { window.removeEventListener('scroll', onScroll); };

    function load() {
      if (busy || !nextUrl) return;
      busy = true;
      loader.classList.add('is-loading');
      btn.hidden = true;
      var url = nextUrl + (nextUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('#product-grid > li');
          var frag = document.createDocumentFragment();
          items.forEach(function (li) { frag.appendChild(document.importNode(li, true)); });
          grid.appendChild(frag);
          var newNav = doc.querySelector('.pagination-wrapper');
          if (nav && newNav) { nav.replaceWith(document.importNode(newNav, true)); }
          nav = container.querySelector('.pagination-wrapper');
          nextUrl = nextUrlFrom(nav);
          busy = false;
          loader.classList.remove('is-loading');
          if (!nextUrl || !items.length) { finish(); return; }
          if (near()) load(); // visitor is already further down (fast scroll) -> keep going
        })
        .catch(function () {
          busy = false;
          loader.classList.remove('is-loading');
          btn.textContent = L.error;
          btn.hidden = false;
          if (root._bttoObserver) root._bttoObserver.disconnect();
        });
    }

    btn.addEventListener('click', function () {
      btn.textContent = L.more;
      load();
      if (root._bttoObserver) root._bttoObserver.observe(loader);
    });

    if ('IntersectionObserver' in window) {
      root._bttoObserver = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) load();
      }, { rootMargin: '0px 0px 900px 0px' });
      root._bttoObserver.observe(loader);
    } else {
      btn.hidden = false;
    }
  }

  function init(root) {
    if (root._bttoInfInit) return;
    root._bttoInfInit = true;
    setup(root);
    var container = root.querySelector('#ProductGridContainer');
    if (container) {
      // facets.js replaces the grid after filtering/sorting -> start again from the new page 1
      new MutationObserver(function (muts) {
        var replaced = muts.some(function (m) {
          return Array.prototype.some.call(m.addedNodes, function (n) {
            return n.nodeType === 1 && (n.id === 'product-grid' || (n.querySelector && n.querySelector('#product-grid')));
          });
        });
        if (replaced) setup(root);
      }).observe(container, { childList: true });
    }
  }

  function boot() { document.querySelectorAll('[data-btto-collection-section]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
